<template>
  <!-- 
  1.화면ID    : MCF_SC_001
  2.화면명    : 영업기회속성 관리 (캡션속성관리)
  3.작성자    : 윤태영 차장
  4.화면설명  : 캡션 ID 기준 영업기회 속성 
               사용여부 Y건에 대해서 미리보기 동적 구현 

  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
  -->

  <div class="content-wrap">
    <!-- 영업기회ID -->
    <div class="row gx-3">
      <div class="col-md-4 col-sm-12">
        <div class="border h-100">
          <div class="code-subtitle">메뉴관리</div>

          <!--메뉴관리 공통컴포넌트-->
          <Tree
          ref="treeRef"
          :menuList="state.treeData"
          :parent-id="'upper_menu_id'"
          :id="'menu_id'"
          :id-nm="'menu_nm'"
          :root-val="''"
          @return="r=>getMenuData(r)"
          />
        
        </div>

      </div>
      <div class="col-md-8 col-sm-12">

        <div class="border h-100">

          <div class="code-subtitle">상세정보</div>
          <div class="p-3">
            <div class="table-responsive table-line table-cf">
              <DataTable
                :value="state.gridRowData"
                editMode="cell"
                :rows="20"
                @cell-edit-complete="onCellEditComplete"
                removableSort
                scrollable
                scrollHeight="400px"
                scrollDirection="both"
                :pt="{
                    column: {
                        bodycell: () => ({
                            style:{textOverflow:'ellipsis', whiteSpace:'nowrap'}
                        }),
                    }
                  }"
              >
              <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
              <!--체크박스 컬럼-->
                <Column>
                  <template #header>
                      <ElCheckbox v-model="allCheck"/>
                  </template>
                  <template #body="{data}">
                      <ElCheckbox 
                      v-model="state.selectRows" 
                      :value="data"
                      />
                  </template>
                </Column>
                <!--데이터 매핑 컬럼-->
                <Column
                  v-for="company of state.gridColumn"
                  :field="company.field"
                  :header="company.headerName"
                  :style="company.style"
                  :key="company.field"
                  :sortable="company.sortable"
                >
                <template #editor="{ data, field }">
                  <ElInput 
                    v-if="field != 'enable_yn'&& field !='cp_required'&& field != 'cd_nm' && field != 'col_id'"
                    style="height: 21px;"
                    :modelValue="data[field]" 
                    @update:modelValue="r=>changeVal(r,data,field)"
                  />

                  <SelectCode
                    style="height: 21px;"
                    id="ynSelect"
                    v-else-if="field === 'enable_yn' || field === 'cp_required'"
                    cd_gr="YN_CD"
                    :matchCd="data[field]"
                    chk_ess="Y"
                    @return="r=>changeVal(r,data,field)"
                  />

                  <SelectCode
                    id="formSelect"
                    style="height: 21px;"
                    v-else-if="field === 'cd_nm'"
                    cd_gr="CAP_CD"
                    :matchCd="data['cd_id']"
                    chk_ess="Y"
                    @return="r=>changeVal(r,data,field)"
                  />

                  <span v-else>{{ data[field] }}</span>

                </template>
                </Column>
              </DataTable>
            </div>

            <!-- 미리보기 컴포넌트-->
            <div class="text-end py-3">
              <ElButton type="primary" @buttonClick="saveRow()">수정</ElButton>
            </div>

          </div>
        </div>


        
                    

      </div>
    </div>

  </div>
</template>
  
<script setup>   
      
import {reactive,toRef,computed ,onBeforeMount } from 'vue'
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Tree           from '@/components/common/SettingTree.vue';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { menuList, cpEdit, cpList } from '@/api/capr';
import SelectCode from '@/components/common/SelectCode.vue';
const previewModalRef   = toRef(null);

onBeforeMount(async()=>{
   await getMenuList();
})

//화면메뉴 리스트 조회
const getMenuList = async() => { 
  try {
    setIsLoading(true)
    const res = await menuList()
    state.treeData = [...res.rtn]
  } catch (err) {
    console.error(err)
    alert('화면메뉴를 불러오는데 실패했습니다.');
  } finally {
    setIsLoading(false)
  }
}

//변수 선언 영역 
const state = reactive({
 
    tb_id : '',            

    salesPropParams : {
   
      caption_nm: [],
      tmpVar    : [],
      dptCount  : null, 
      enable_yn : [],
  
    },

    selectRows: [],
  
      //컬럼 셋팅
      gridColumn :[
      { headerName: '캡션명',        style: {minWidth: "50px",maxWidth: "100px", overflow:'hidden'},   field: "caption_nm"},
      { headerName: '캡션속성',      style: {minWidth: "70px",maxWidth: "75px"},   field: "cd_nm"}, 
      { headerName: '캡션속성값',    style: {minWidth: "70px",maxWidth: "70px", overflow:'hidden'},   field: "cp_cd" },
      { headerName: '필수여부',  style: {minWidth: "65px",maxWidth: "65px"},   field: "cp_required"}, 
      { headerName: '사용여부',  style: {minWidth: "65px",maxWidth: "65px"},  field: "enable_yn"},   
      { headerName: '우선순위',  style: {minWidth: "60px",maxWidth: "60px", overflow:'hidden'},   field: "view_sort"}, 

      { headerName: '비고',      style: {minWidth: "50px",maxWidth: "70px", overflow:'hidden'},   field: "note"},
      ],

    gridRowData: [],

    menu : {
        menu_id : '',
        menu_nm : '',
        upper_menu_id : '',
        enable_yn : ''
        },
 
    
});
 
const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectRows.length;
  },
  set(newValue) {
    state.selectRows = newValue
      ? state.gridRowData.map((item) => {
          return item;
        })
      : [];
  },
});

//수정 함수  (cpEdit)
const saveRow = async () => {
    if(state.selectRows.length >= 1 ){
      try {
        setIsLoading(true)
        let cnt = 0
        for(let item of state.selectRows){
          const res = await cpEdit(item)
          cnt+=1
        }
        alert(`총 ${state.selectRows.length}건 중에 ${cnt} 수정완료했습니다.`);
        state.selectRows
      } catch (err) {
        console.error('error', err)
        alert('메뉴 상세정보 수정 에러');
      } finally {
        setIsLoading(false)
      }
    }
  else{
    alert('선택된 행이 없습니다.');
  }
};


// 모달팝업
const openModal = (modal) =>{
    let sRows     = [];
    let sRowsCnt  = state.selectRows.length;
    let sValue    = state.selectRows;
   
    if(modal == 'preview'){
     sRows = state.selectRows;

     if(sRows?.length > 0 ){
      state.salesPropParams.tmpVar = [];
      state.salesPropParams.enable_yn = [];
         
          for(let item of sRows){
              state.salesPropParams.tmpVar.push(item['caption_nm']);
              state.salesPropParams.enable_yn.push(item['enable_yn']);
              
              let rValue = JSON.stringify(state.salesPropParams.tmpVar);
          }
          //props 데이터 대입
          state.salesPropParams.dptCount = sRowsCnt;
          state.salesPropParams.caption_nm = state.salesPropParams.tmpVar;
          state.salesPropParams.enable_yn  = state.salesPropParams.enable_yn;
          previewModalRef.value.openModal();
      }
    }  
    
    if(sRows?.length  == 0 ){
      alert('선택된 행이 없습니다.');
    }
  
}
const getMenuData = (menu) => {
  let searchFlag = true

  state.treeData.forEach((item)=>{
    if(item.upper_menu_id === menu.menu_id){
      searchFlag = false
    }
  })

  if(searchFlag) getDataSubList(menu); // 상세정보 
}

//상세정보 조회
const getDataSubList = async (menu) =>{

  let params = {
    scren_id : menu.scren_id,
    tb_id  :   menu.tb_id,  // 캡션속성관리 id  ( lead, event, comp, sales_opty,user_info ): 운영할때는 코드값 추천)
  }
  // 서버 현시점(2024.03.13) 설계 진행 완료    
  try {
    setIsLoading(true)
    const res = await cpList(params)
    if (!res.rtn.length) {
      alert('결과값이 없습니다.')
      return
    }

    state.gridRowData = [...res.rtn]; 

  
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
};


const onCellEditComplete = (code) => {
    let { data ,newValue, field,newData } = code;

    data[field] = newValue

    // state.selectRows.push(newData.index)
};

const changeVal = (val,data,field)=>{
  switch(field){
    case 'cd_nm': 
      data[field] = val.cd_nm
      data['cd_id'] = val.cd_id
      state.gridRowData = state.gridRowData.map((item)=>{
        if(item.cp_seq === data.cp_seq){
          return data
        }
        return item
      })
    break

    case 'cd_nm': 
      data[field] = val.cd_nm
      data['cd_id'] = val.cd_id
    break

    case 'enable_yn':
      data[field] = val.cd_id
    break

    case 'cp_required':
      data[field] = val.cd_id
    break

    default : 
      data[field] = val

  }

   
}


  </script>
  